import React from 'react';
import styled from 'styled-components';
import media from 'styled-media-query';

import ResetCSS from '../../atoms/ResetCSS';

import Logo from '../../../static/image/logo.svg';
import MaintenanceNewsBanner from '../../../static/image/banner_maintenance_news.svg';

export const Maintenance = (): JSX.Element => (
  <React.Fragment>
    <ResetCSS />

    <Header>
      <img src={Logo} alt="Samurai" />
    </Header>

    <Main>
      <Content>
        <Text>メンテナンス中</Text>
        <Message>
          申し訳ございませんが、現在対象ページはメンテナンス中のためアクセスできません。
          <br />
          時間を置いたのち、再度アクセスをお願いします。
          <br />
        </Message>
        <NewsLink href="https://www.sejuku.net/education/" target="_blank" rel="noopener noreferrer">
          <img src={MaintenanceNewsBanner} alt="SAMURAI 公式サイト" />
        </NewsLink>
        <Caption>最新情報は上記バナーからご確認ください。</Caption>
      </Content>
    </Main>
  </React.Fragment>
);

const Header = styled.header`
  display: flex;
  width: 100%;
  height: 67px;
  align-items: center;
  background-color: #ffffff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 0 2rem;
  box-sizing: border-box;

  img {
    height: 1.5rem;
  }

  ${media.lessThan('medium')`
    padding: 0 1rem;
  `}
`;

const Main = styled.main`
  box-sizing: border-box;
  padding: 80px 32px;

  ${media.lessThan('medium')`
    padding: 32px;
  `}

  h2 {
    font-size: 20px;
    color: rgba(0, 0, 0, 0.87);
    font-weight: 600;
  }
`;

const Content = styled.section`
  box-sizing: border-box;
  margin: 0 auto;
  max-width: 848px;
  padding: 62px 99px 80px;
  background-color: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  text-align: center;

  ${media.lessThan('medium')`
    padding: 2rem;
  `}
`;

const Text = styled.h3`
  display: block;
  font-size: 90px;
  line-height: 108px;
  font-weight: 700;
  color: #d02c2a;
  text-align: center;

  ${media.lessThan('medium')`
    font-size: min(40px, calc((100vw - 160px) / 7));
    line-height: 1.2;
  `}
`;

const Message = styled.p`
  margin-top: 1rem;
  font-size: 16px;
  line-height: 20px;
  color: rgba(0, 0, 0, 0.87);
`;

const NewsLink = styled.a`
  display: inline-block;
  margin-top: 2rem;
  max-width: 100%;

  img {
    max-width: 100%;
  }
`;

const Caption = styled.p`
  margin-top: 6px;
  font-size: 16px;
  line-height: 20px;
  color: #111111;
  text-align: center;
`;
